import { useState } from 'react';
import { Link } from 'react-router-dom';
import { siteNav } from '@/mocks/home';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background-50/90 backdrop-blur-md hairline">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:h-[72px] md:px-6 lg:px-10">
        <h1 className="flex shrink-0 items-center gap-2.5">
          <Link to="/" className="flex items-center gap-2.5" aria-label="爱黑料网首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-base font-black text-background-50">
              黑
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
                爱黑料网
              </span>
              <span className="mt-0.5 text-[10px] uppercase tracking-[0.22em] text-foreground-500">
                gossip lounge
              </span>
            </span>
          </Link>
        </h1>

        <nav className="ml-2 hidden items-center gap-1 lg:flex" aria-label="主导航">
          {siteNav.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className={`cursor-pointer whitespace-nowrap rounded-md px-3.5 py-2 text-sm transition-colors ${
                item.active
                  ? 'bg-secondary-100 font-semibold text-secondary-900'
                  : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-950'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-3 md:flex">
          <label className="flex h-10 w-56 items-center gap-2 rounded-md border bg-background-100 px-3 hairline focus-within:border-primary-300 lg:w-64">
            <i className="ri-search-line text-base text-foreground-400"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜黑料、瓜帖、热评"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
          </label>
          <a
            href="#subscribe"
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            加入吃瓜
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="打开菜单"
          className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border text-foreground-800 hairline md:hidden"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-2-line'}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t bg-background-50 px-4 py-4 hairline md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {siteNav.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <div className="mt-3 flex flex-col gap-3">
            <label className="flex h-10 items-center gap-2 rounded-md border bg-background-100 px-3 hairline">
              <i className="ri-search-line text-base text-foreground-400"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜黑料、瓜帖、热评"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </label>
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              加入吃瓜
            </a>
          </div>
        </div>
      )}
    </header>
  );
}